import classNames from 'classnames';
import styles from './selectedItem.module.scss';

type TDropdownSelectItemProps<T> = {
  item: T;
  optionTitle: keyof T;
  removeItem: (item: T) => void;
};

const DropdownSelectItem = <T extends Record<string, string | number>>({
  item,
  optionTitle,
  removeItem,
}: TDropdownSelectItemProps<T>) => {
  return (
    <>
      <div
        className={classNames(
          styles['selected-dropdown-item'],
          'd-flex justify-content-center align-items-center',
        )}
      >
        <small>{item[optionTitle]}</small>

        <i
          className="icon-Clean-search me-2"
          onClick={() => removeItem(item)}
        ></i>
      </div>
    </>
  );
};

export default DropdownSelectItem;
